<template>
    <div class="contact-status-widget">
        <div class="widget-contents-container">
            <div class="widget-header">
                <h3>Contact Status</h3>
                <div class="svg-container widget-close-button" @click="closeWidget">
                    <widget-close-svg />
                </div>
            </div>
            <div class="content-wrapper">
                <loading-screen-svg v-if="isLoading" />
                <div class="form-wrapper" v-else>
                        <div class="input-container">
                            <app-input 
                                v-model="contactStatus.name"
                                placeholder="Name" 
                                :label="'Name'" 
                                :isValid="!submitted || $v.contactStatus.name.required"
                                :error="`Name is required`"
                            />
                        </div>
                        <div class="input-container">
                            <status-color-dropdown v-model="contactStatus.color" :label="'Color'" />
                        </div>
                </div>
                
            </div> 
            <div class="widget-footer">
                <div class="cancel-container">
                    <app-button class="cancel-btn transparent-btn" @click="closeWidget">
                        Cancel
                    </app-button>
                </div>
                <div class="action-container">
                    <app-button @click="save()">Save</app-button>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
const AppButton = () => import('@/components/common/app-button.vue');
const WidgetCloseSvg = () => import('@/components/svg/quick-add/widget-close-svg.vue');
const AppInput = () => import('@/components/common/app-input.vue');
const LoadingScreenSvg = () => import('@/components/svg/loading-screen-svg');
const StatusColorDropdown = () => import('@/components/common/status-color-dropdown');
const AppColorCircle = () => import('@/components/common/app-color-circle');



import EventBus from '@/scripts/event-bus.js';
import { required} from 'vuelidate/lib/validators';

export default {
    name: 'contact-status-widget',

    props: {
        widget: {
            type: Object,
            required: true
        }
    },

    components: {
        'app-button': AppButton,
        'widget-close-svg': WidgetCloseSvg,
        'app-input': AppInput,
        'loading-screen-svg': LoadingScreenSvg,
        'status-color-dropdown': StatusColorDropdown,
        'app-color-circle': AppColorCircle,
       
    },

    data() {
        return {
            submitted: false,
            isLoading: true,
            contactStatus: {
                id: this.widget.contactStatusId,
                clientId: this.widget.clientId,
                name: null,
                color: 'Dark Cold Steel',
            },
        }
    },

    validations: {
        contactStatus: {
            name: {
                required
            },
        },
    },

    methods: {
        closeWidget() {
            EventBus.$emit('close-widget', this.widget);
        },

        save() {
            this.submitted = true;
            this.$v.$touch();

            if (this.$v.$invalid) {
                return;
            }

            if(this.contactStatus.id) {
                this.patch();
            } 
            else {
                this.post();
            }
        },

        patch() {
            this.isLoading = true;

            var changes = [{
                'name': 'Name',
                'value': this.contactStatus.name
            }, {
                'name': 'Color',
                'value': this.contactStatus.color
            }];

            this.$api
                .patch(`/api/ContactStatuses/${ this.contactStatus.id }`, changes)
                .then(response => {
                    this.$helpers.showSuccessNotification('Your contact status has been successfully updated.');
                    EventBus.$emit('contact-status:update');
                    this.closeWidget();
                })
                .catch((error) => {
                    this.isLoading = false;
                    this.$helpers.showFailNotification('An error occurred while updating your contact status.', { error });
                });
        },

        post() {
            this.isLoading = true;

            var contactStatus = {
                Name: this.contactStatus.name,
                Color: this.contactStatus.color,
                ClientId: this.contactStatus.clientId,
            };

            this.$api
                .post(`/api/ContactStatuses`, contactStatus)
                .then(response => {
                    this.$helpers.showSuccessNotification('Your contact status has been successfully created.');
                    EventBus.$emit('contact-status:update');
                    this.closeWidget();
                })
                .catch((error) => {
                    this.isLoading = false;
                    this.$helpers.showFailNotification('An error occurred while creating your contact status.', { error });
                });
        },

        getContactStatus() {
            this.isLoading = true;

            this.$api
                .get(`/service/ContactStatuses?$filter=Id eq ${ this.contactStatus.id }`)
                .then(response => {
                    this.contactStatus.id = response.data.value[0].Id;
                    this.contactStatus.name = response.data.value[0].Name;
                    this.contactStatus.color = response.data.value[0].Color;
                })
                .catch((error) => {
                    this.$helpers.showFailNotification('An error occurred while fetching your contact status.', { error });
                })
                .finally(() => {
                    this.isLoading = false;
                });
        }
    },

    created() {
        if (this.contactStatus.id) {
            this.getContactStatus();
        }
        else {
            this.isLoading = false;
        }
    }
}
</script>

<style>
.contact-status-widget .form-wrapper {
    display: flex;
    flex-direction: column;
}

.contact-status-widget .widget-contents-container .transparent-btn {
    background: transparent;
    color: #877D88;
    border: none;
}

.contact-status-widget .widget-contents-container .transparent-btn:hover {
    background: #E1E0E5;
}

.contact-status-widget .app-input input {
        padding: 8px 15px;
}

.contact-status-widget .app-input input:hover {
    padding: 7px 14px;
}

.contact-status-widget .app-input input:active, .app-input input:focus {
    border: solid #18aeff;
    background-color: #fff;
    border-width: 2px;
    padding: 7px 14px;
}

.contact-status-widget .status-color-dropdown  {
    max-width: 100px;
    margin-right: 10px;
}

.contact-status-widget .app-input {
    margin-bottom: 16px;
}

.contact-status-widget p{
    display: block;
    font: 500 16px / 1em 'Roboto';
    margin-bottom: 7px;
    color: #382153;
}


</style>